module.exports = __webpack_public_path__ + "img/Logo.47272f00.png";